import { useQuery } from '@tanstack/react-query'
import { settingsService } from 'v2/shared/services/settings-service'
import { conversationQueryKeys } from 'v2/shared/utils/query-key-management'

export const useDownloadFile = (fileName?: string) =>
  useQuery({
    queryKey: conversationQueryKeys().downloadFile(fileName || ''),
    retry: false,
    queryFn: () => settingsService.downloadFile(fileName || ''),
    enabled: !!fileName,
  })
